





















import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import DefaultLayout from '@/views/layouts/DefaultLayout.vue';
import NavigationDrawerMenu from '@/components/NavigationDrawerMenu.vue';

@Component({
  components: { DefaultLayout, NavigationDrawerMenu }
})

export default class PublicLayout extends Mixins<SlotMixin>(SlotMixin) {
  drawer:boolean = false;
}
